import React from 'react';

import MuiLink from '@mui/material/Link';
import { Link as WouterLink } from 'wouter';

// an <a> which delegates the routing to wouter's <Link> and the presentation
// to material UI's <Link>
//
// if the href is falsy, directly render the children without wrapping them in
// a link
const Link = ({ href, children, sx = {}, ...rest }) => {
  if (!href) {
    return children;
  }

  return (
    <WouterLink href={href} asChild>
      <MuiLink sx={{ color: 'inherit', ...sx }} {...rest}>
        {children}
      </MuiLink>
    </WouterLink>
  );
};

export default Link;
